import axios from 'axios'

import wcs from '@/scripts/libs/wcs'

enum NewsletterRegistrationGender {
  M = 'M',
  F = 'F',
  N = 'N',
}

interface SubmitNewsletterRegistrationParameters {
  signUpEmail: string
  gender?: NewsletterRegistrationGender
  birthday?: string
}
export class WcsNewsletter {
  static FORM_STATES_OK = 'FORM_STATES_OK'
  static FORM_STATES_WARNING = 'FORM_STATES_WARNING'
  static FORM_STATES_KO = 'FORM_STATES_KO'
  static FORM_STATES_LOADING = 'FORM_STATES_LOADING'
  static FORM_STATES_INIT = 'FORM_STATES_INIT'

  static submitNewsletterRegistration = async function (
    signUpEmail: string,
    gender?: NewsletterRegistrationGender,
    birthday?: string
  ) {
    try {
      const params: SubmitNewsletterRegistrationParameters = { signUpEmail }
      if (gender) {
        params.gender = gender
      }
      if (birthday) {
        params.birthday = birthday
      }
      const response = await axios.get(wcs.getEndPoint('newsletterRegistration'), {
        params: {
          ...params,
        },
      })
      let status = null
      if ('number' === typeof response.status) {
        status = response.status
      } else if ('string' === typeof response.status) {
        status = Number.parseInt(response.status)
      }
      const result: { stateForm: string; cause?: string } = {
        stateForm: WcsNewsletter.FORM_STATES_KO,
      }
      switch (status) {
        case 200:
          result.stateForm = WcsNewsletter.FORM_STATES_OK
          break
        case 201:
          result.stateForm = WcsNewsletter.FORM_STATES_WARNING
          result.cause = 'email_already_registered'
          break
      }
      return result
    } catch (e) {
      if (e instanceof Error) {
        return e.message
      }
    }
  }
}
